import axios from "axios";

// Use relative path to leverage Nginx proxy reversal — browser sees same-origin, no CORS needed.
// withCredentials sends the httpOnly `kawa_session` cookie automatically; there is no
// token in JS state anymore, so no Authorization header to build here.
export const apiClient = axios.create({
  baseURL: "/api",
  withCredentials: true,
});
